import React from "react";
import { history } from "../store";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchMachines, updateMachineTPV } from "../actions/machines";

import MachineStatusBadge from "./MachineStatusBadge";
import MachineCashBadge from "./MachineCashBadge";

class TPVList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: {}, // map of "Serial_field" => boolean
      inputs: {}, // map of "Serial_field" => input value
    };
  }

  startEditing = (serial, field, currentValue) => {
    const key = `${serial}_${field}`;
    this.setState((prev) => ({
      editing: { ...prev.editing, [key]: true },
      inputs: { ...prev.inputs, [key]: currentValue },
    }));
  };

  cancelEditing = (serial, field) => {
    const key = `${serial}_${field}`;
    this.setState((prev) => ({
      editing: { ...prev.editing, [key]: false },
      inputs: { ...prev.inputs, [key]: "" },
    }));
  };

  handleInputChange = (serial, field, value) => {
    const key = `${serial}_${field}`;
    this.setState((prev) => ({
      inputs: { ...prev.inputs, [key]: value },
    }));
  };

  handleSave = async (serial, machineId, field) => {
    const key = `${serial}_${field}`;
    const { inputs } = this.state;
    const { updateMachineTPV, fetchMachines } = this.props;

    const newValue = inputs[key];

    const response = await updateMachineTPV(machineId, { [field]: newValue });

    if (!response.error) {
      if (typeof fetchMachines === "function") {
        fetchMachines();
      }

      this.setState((prev) => ({
        editing: { ...prev.editing, [key]: false },
      }));
    } else {
      alert(`Error actualizando el campo ${field}`);
    }
  };

  goTo(Serial, e) {
    history.push(`/machines/${Serial}`);
  }

  getTPVPresent(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && machine.Tpv_serial) {
        return true;
      }
    }
  }

  generateTpvPassFromSerial(sn) {
    if (!sn || sn.length < 8) return null; // sanity check

    // build pass as: 8th digit + 3rd + 4th + 6th + 7th + last
    const digits = sn.split("");
    return (
      digits[7] + // 8th
      digits[2] + // 3rd
      digits[3] + // 4th
      digits[5] + // 6th
      digits[6] + // 7th
      digits[digits.length - 1] // last
    );
  }

  getDeviceModel(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];
      if (
        device.Type === "TPV" &&
        (device.Device === "PAYTEF" || device.Device === "SPIRE")
      ) {
        return <span>SPu90</span>;
      } else if (device.Type === "TPV") {
        return <span>{device.Device}</span>;
      } else {
        return <span>NO DEVICE</span>;
      }
    }

    return <span>NO DEVICE</span>;
  }

  getPlatform(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];
      if (device.Type === "TPV" && device.Device === "PAYTEF") {
        return <span>{device.Device}</span>;
      } else if (device.Type === "TPV" && device.Device === "Q5000") {
        return <span>WIPAY</span>;
      } else if (device.Type === "TPV" && device.Device === "Q6000") {
        return <span>COMERCIA</span>;
      } else if (device.Type === "TPV") {
        return <span>REDSYS</span>;
      }
    }
  }

  getDeviceType(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && device.Device != "PAYTEF") {
        return true;
      }
    }
  }

  getMerchantCode(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && device.Device === "PAYTEF") {
        return true;
      }
    }
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Máquina</th>
              <th scope="col">Cliente</th>
              <th scope="col">Modelo</th>
              <th scope="col">Plataforma</th>
              <th scope="col">SN</th>
              <th scope="col">Pass</th>
              <th scope="col">C. Comercio</th>
              <th scope="col">TCOD</th>
              <th scope="col">Clave Firma</th>
              <th scope="col">Terminal</th>
            </tr>
          </thead>
          <tbody>
            {this.props.machines.map((machine) => {
              const hasQ6000 = machine.PaymentDevices?.some(
                (d) => d.Type === "TPV" && d.Device === "Q6000"
              );

              let displayPass = machine.Tpv_pass;
              let isAutogenerated = false;

              if (!displayPass && hasQ6000 && machine.Tpv_serial) {
                displayPass = this.generateTpvPassFromSerial(
                  machine.Tpv_serial
                );
                isAutogenerated = true;
              }

              return (
                <tr
                  key={machine.Serial}
                  className={
                    this.getTPVPresent(machine) ? "" : "bg-danger text-white"
                  }
                >
                  <th scope="row">{machine.Serial}</th>
                  <td>
                    {(machine.Customer && machine.Customer.Fullname) || "None"}
                  </td>
                  <td>{this.getDeviceModel(machine)}</td>
                  <td>{this.getPlatform(machine)}</td>

                  {/* SN editable field */}
                  <td>
                    {this.state.editing[`${machine.Serial}_Tpv_serial`] ? (
                      <div className="d-flex align-items-center">
                        <input
                          className="form-control form-control-sm"
                          value={
                            this.state.inputs[`${machine.Serial}_Tpv_serial`] ||
                            ""
                          }
                          onChange={(e) =>
                            this.handleInputChange(
                              machine.Serial,
                              "Tpv_serial",
                              e.target.value
                            )
                          }
                          style={{ maxWidth: "120px" }}
                        />
                        <button
                          className="btn btn-success btn-sm ml-1"
                          onClick={() =>
                            this.handleSave(
                              machine.Serial,
                              machine._id,
                              "Tpv_serial"
                            )
                          }
                        >
                          <i className="fas fa-check"></i>
                        </button>
                        <button
                          className="btn btn-secondary btn-sm ml-1"
                          onClick={() =>
                            this.cancelEditing(machine.Serial, "Tpv_serial")
                          }
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <span>{machine.Tpv_serial || "-"}</span>
                        <button
                          className="btn bg-warning text-dark btn-outline-light btn-sm ml-2"
                          onClick={() =>
                            this.startEditing(
                              machine.Serial,
                              "Tpv_serial",
                              machine.Tpv_serial
                            )
                          }
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </div>
                    )}
                  </td>

                  {/* Pass editable field */}
                  <td>
                    {this.state.editing[`${machine.Serial}_Tpv_pass`] ? (
                      <div className="d-flex align-items-center">
                        <input
                          className="form-control form-control-sm"
                          value={
                            this.state.inputs[`${machine.Serial}_Tpv_pass`] ||
                            ""
                          }
                          onChange={(e) =>
                            this.handleInputChange(
                              machine.Serial,
                              "Tpv_pass",
                              e.target.value
                            )
                          }
                          style={{ maxWidth: "120px" }}
                        />
                        <button
                          className="btn btn-success btn-sm ml-1"
                          onClick={() =>
                            this.handleSave(
                              machine.Serial,
                              machine._id,
                              "Tpv_pass"
                            )
                          }
                        >
                          <i className="fas fa-check"></i>
                        </button>
                        <button
                          className="btn btn-secondary btn-sm ml-1"
                          onClick={() =>
                            this.cancelEditing(machine.Serial, "Tpv_pass")
                          }
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        {isAutogenerated ? (
                          <span className="text-warning font-italic">
                            {displayPass} <small>(auto)</small>
                          </span>
                        ) : (
                          <span>{displayPass || "-"}</span>
                        )}
                        <button
                          className="btn bg-warning text-dark btn-outline-light btn-sm ml-2"
                          onClick={() =>
                            this.startEditing(
                              machine.Serial,
                              "Tpv_pass",
                              machine.Tpv_pass
                            )
                          }
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </div>
                    )}
                  </td>

                  {this.getDeviceType(machine) ? (
                    <td>{machine.TpvBusinessCode}</td>
                  ) : (
                    <td>-</td>
                  )}
                  {this.getMerchantCode(machine) ? (
                    <td>{machine.Tpv_tcod}</td>
                  ) : (
                    <td>-</td>
                  )}
                  {this.getDeviceType(machine) ? (
                    <td>{machine.TpvFirmKeyCode}</td>
                  ) : (
                    <td>-</td>
                  )}
                  {this.getDeviceType(machine) ? (
                    <td>{machine.TpvTerminalCode}</td>
                  ) : (
                    <td>-</td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  updateMachineTPV: bindActionCreators(updateMachineTPV, dispatch),
});

export default connect(null, mapDispatchToProps)(TPVList);
